/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';
import { Form, InputGroup, Alert } from 'react-bootstrap';

export const NumberForm = styled(Form.Control)`
  width: 30%;
  height: 60px;
  @media (max-width: 480px) {
    width: 100%;
    height: 80px;
  }
`;

export const GroupInput = styled(InputGroup)`
  width: 100%;
  height: 60px;
  @media (max-width: 480px) {
    width: 90%;
    height: 80px;
  }
`;

export const GroupText = styled(InputGroup.Text)`
  cursor: pointer;
  color: #fff;
`;

export const AlertComp = styled(Alert)`
  display: block;
  font-size: 10px !important;
  padding: 4px !important;
  margin-top: 4px !important;
`;
